import { z } from 'zod';
const trim = z.string().trim();
export const createSupplierInput = z.object({
    fullName: trim.min(1).max(160),
    vat: trim.max(20).optional().nullable(),
    taxCode: trim.max(20).optional().nullable(),
    email: z.string().email().optional().nullable(),
    phone: trim.max(40).optional().nullable(),
    city: trim.max(80).optional().nullable(),
    hourlyRate: z.coerce.number().min(0).max(10000).optional().nullable(),
    dailyRate: z.coerce.number().min(0).max(100000).optional().nullable(),
    active: z.boolean().default(true),
    notes: trim.max(5000).optional().nullable(),
    skills: z.array(z.string()).default([]),
});
export const updateSupplierInput = createSupplierInput.partial();
//# sourceMappingURL=supplier.js.map